import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import eagle from '../../../../assets/images/markets/other/risk/eagle.svg';
import './Risk.css';

const Risk = ({ title = 'Risk Considerations', text, eagleImage }) => {
  if (!text) {
    return null;
  }

  return (
    <section className="market-risk">
      <div className="market-risk__inner">
        <div className="market-risk__panel">
          <Reveal className="market-risk__content">
            <img
              className="market-risk__eagle"
              src={eagleImage || eagle}
              alt=""
              aria-hidden="true"
            />
            <h2 className="market-risk__title">{title}</h2>
            <p className="market-risk__text">{text}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Risk;
